import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[attributeChoiceDetailDirective]'
})
export class AttributeChoiceDetailDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
